module.exports = __webpack_public_path__ + "img/champion.62a9f371.png";